module.exports = __webpack_public_path__ + "static/media/loader-resultados.d6069ecc.gif";